export default __webpack_public_path__ + "static/media/16.8cd55c81.jpg";